import {Box, Stack, Typography, useTheme} from "@mui/material";
import ProductItem from "./ProductItem";
import {Element} from "react-scroll";
import ScrollAnimation from "react-animate-on-scroll";
import {useTranslations} from "../../store/LanguageProvider";

const CategoryName = (props) => {
    const theme = useTheme();
    return <ScrollAnimation animateIn='zoomIn' offset={50}>
        <Box
            height={30}
            pt={3}
            pb={1}
            sx={{position: 'relative'}}>
            <Stack direction='row' alignItems='center' px={3}>
                <div style={{
                    border: `1px solid ${theme.palette.brAccent.dark}`,
                    height: 0,
                    flexGrow: 1
                }}/>
                <Typography
                    variant='h4'
                    fontSize='1.2rem'
                    color={theme.palette.brAccent.dark}
                    mx={2}
                    sx={{
                        display: 'inline-block',
                        textTransform: 'uppercase'
                    }}
                >{props.name}</Typography>
                <div style={{
                    border: `1px solid ${theme.palette.brAccent.dark}`,
                    height: 0,
                    flexGrow: 1
                }}/>
            </Stack>
        </Box>
    </ScrollAnimation>
}

const CategoryProducts = (props) => {
    const {currentLang} = useTranslations();

    const products = props.data.map(p => {
        const name = (p.translations[currentLang] && p.translations[currentLang].name) ?
            p.translations[currentLang].name : p.name;
        const description = (p.translations[currentLang] && p.translations[currentLang].description) ?
            p.translations[currentLang].description : p.description;

        return <ProductItem
            key={p.id}
            name={name}
            description={description}
            price={p.price}
            allergens={p.allergens}/>
    });
    return <>
            <Stack direction='column'>
                <Element id={`cat-${props.id}`} name={`cat-${props.id}`}>
                    <CategoryName name={props.name} />
                    {products}
                </Element>
            </Stack>
    </>
}

const ProductList = (props) => {
    const {currentLang} = useTranslations();

    const menu = props.data
        .filter(c => c.products.length > 0)
        .map(c => {
            let name = c.name;
            if (c.translations && c.translations[currentLang] && c.translations[currentLang].name){
                name = c.translations[currentLang].name;
            }

            return <CategoryProducts
                key={c.id}
                id={c.id}
                name={name}
                data={c.products} />
        })

    return <Box mt={3}>
        {menu}
    </Box>
}

export default ProductList;